<mat-drawer-container class="setting-container" autosize>
    <mat-drawer #drawer class="setting-sidenav" mode="side" opened="true">
        <mat-list>
            @for (setting of settingTabs; track setting) {
                @if (setting?.canView) {
                    <mat-list-item
                        (click)="tabIndexChanged(setting.url)"
                        [class.selected]="currentTab === setting.url"
                    >
                        {{ setting.name }}
                    </mat-list-item>
                }
            }
        </mat-list>
    </mat-drawer>

    <div class="cb-margin-top">
        <router-outlet> </router-outlet>
    </div>
</mat-drawer-container>
